/**
 * Parse GitLab URLs — works with gitlab.com and self-hosted instances.
 * Supports:
 * - https://gitlab.com/group/project
 * - https://git.company.com/group/subgroup/project
 * - https://gitlab.com/group/project/-/blob/main/path/to/file.TcPOU
 * - https://git.company.com/group/project/-/tree/main/path/folder
 */
export const parseGitlabUrl = (url) => {
  if (!url || typeof url !== 'string') return null;

  try {
    const urlObj = new URL(url);
    const baseUrl = `${urlObj.protocol}//${urlObj.host}`;
    const parts = urlObj.pathname.split('/').filter(p => p);
    if (parts.length < 2) return null;

    const dashIndex = parts.indexOf('-');

    if (dashIndex === -1) {
      return { ownerRepo: '/' + parts.join('/'), branch: null, filePath: null, type: 'repo', baseUrl };
    }

    const projectParts = parts.slice(0, dashIndex);
    if (projectParts.length < 2) return null;

    const typeIndicator = parts[dashIndex + 1];
    if (!typeIndicator || (typeIndicator !== 'blob' && typeIndicator !== 'tree')) {
      return { ownerRepo: '/' + projectParts.join('/'), branch: null, filePath: null, type: 'repo', baseUrl };
    }

    const branchStart = dashIndex + 2;
    if (branchStart >= parts.length) {
      return { ownerRepo: '/' + projectParts.join('/'), branch: null, filePath: null, type: 'repo', baseUrl };
    }

    const branch = parts[branchStart];
    const filePathParts = parts.slice(branchStart + 1);
    const filePath = filePathParts.join('/');

    let type = typeIndicator === 'blob' ? 'blob' : 'tree';
    if (type === 'blob' && filePathParts.length > 0) {
      const lastPart = filePathParts[filePathParts.length - 1];
      if (!lastPart.includes('.')) type = 'tree';
    }

    return { ownerRepo: '/' + projectParts.join('/'), branch, filePath: filePath || null, type, baseUrl };
  } catch (e) {
    return null;
  }
};

export const isValidGitlabUrl = (url) => {
  return parseGitlabUrl(url) !== null;
};
